import { Text } from '@nimbus-ds/components';
import { Stack } from 'commons/components';

function RulesListSkeleton() {
  return (
    <Stack column align="flex-start">
      <Text.Skeleton width="20%" />
      <Text.Skeleton width="50%" />
      <Text.Skeleton width="20%" />
      <Text.Skeleton width="50%" />
    </Stack>
  );
}

export default RulesListSkeleton;
